import React from "react";
import { Alert, AlertTitle, Button, Snackbar } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";
import { useTranslation } from "../context/Internationalization";
import { hasFirebaseAction } from "../auth/consoleSession";
import useDeploymentUpdate from "../Hooks/useDeploymentUpdate";
import { LOGIN_ROUTE, REGISTRATION_ROUTE } from "../routes";

export default function DeploymentUpdateNotice() {
  const auth = useAuthContext();
  const { pathname, search } = useLocation();
  const { t } = useTranslation();
  const currentPath = pathname.toLowerCase();
  const isAuthRoute = [LOGIN_ROUTE, REGISTRATION_ROUTE].some(
    (route) => currentPath === route || currentPath.startsWith(`${route}/`)
  );
  const enabled = auth.sessionStatus === "ready" &&
    auth.session?.kind === "established" && !auth.inlineSignInPending &&
    !isAuthRoute && !hasFirebaseAction(search);
  const updateAvailable = useDeploymentUpdate(enabled);

  // Hide immediately on logout or navigation into an account/registration flow.
  if (!enabled || !updateAvailable) return null;

  return (
    <Snackbar open autoHideDuration={null} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
      <Alert
        severity="info"
        role="status"
        aria-label={t("deployment_update_title")}
        action={
          <Button color="inherit" size="small" onClick={() => window.location.reload()}>
            {t("deployment_update_refresh")}
          </Button>
        }
        sx={{ maxWidth: 560, alignItems: "center", "& .MuiAlert-message": { minWidth: 0 } }}
      >
        <AlertTitle>{t("deployment_update_title")}</AlertTitle>
        {t("deployment_update_description")}
      </Alert>
    </Snackbar>
  );
}
